module.exports = __webpack_public_path__ + "static/media/tuzoHorizontal.db681982.png";